import React from 'react';
import { BrainGraph } from '../components/deck/BrainGraph';
import { Slide } from '../components/deck/Slide';
import { Caption, Eyebrow, INK, Reveal, Title } from '../components/deck/Type';
const loop = [{
  angle: -90,
  label: 'More investment organizations',
  tone: INK.blue
}, {
  angle: -30,
  label: 'More companies and opportunities',
  tone: INK.blue
}, {
  angle: 30,
  label: 'More decisions and feedback',
  tone: INK.violet
}, {
  angle: 90,
  label: 'More portfolio and exit outcomes',
  tone: INK.gold
}, {
  angle: 150,
  label: 'Stronger venture intelligence',
  tone: INK.emerald
}, {
  angle: 210,
  label: 'Better sourcing and decisions',
  tone: INK.emerald
}];
const moat = ['Proprietary venture-data structure', 'Venture Industry Classification System', 'Decision and outcome intelligence', 'Organization-level memory', 'Two provisional patents', 'Workflow integration', 'Historical and real-time data signals'];
function position(angle: number, radius = 50) {
  const rad = angle * Math.PI / 180;
  return {
    left: `${50 + Math.cos(rad) * radius}%`,
    top: `${50 + Math.sin(rad) * radius}%`
  };
}
export function FlywheelSlide() {
  return <Slide index={11} data-id="element-93" data-mp="1c199v7gck1i6">
      <div className="flex items-start justify-between gap-[3vw]" data-id="element-94" data-mp="1pv0jsgxzpnef">
        <div className="max-w-[60%]" data-id="element-95" data-mp="1pwbmsejm2r4h">
          <Eyebrow data-id="element-96" data-mp="1l3ifpk0o76p8">The moat</Eyebrow>
          <Title className="mt-[2.2vh]" data-id="element-97" data-mp="1l2h4nfjnmk7i">
            Every customer makes the intelligence layer more valuable.
          </Title>
        </div>
        <Caption className="max-w-[30%] text-right" data-id="element-98" data-mp="1uttvc3tpv4by">
          Structure compounds: entities, criteria, decisions and outcomes all
          strengthen the knowledge graph.
        </Caption>
      </div>

      <div className="mt-auto grid min-h-0 flex-1 grid-cols-[54%_1fr] items-center gap-[3vw]" data-id="element-99" data-mp="24s125tuak608">
        <div className="relative flex h-full items-center justify-center" data-id="element-100" data-mp="ef20zld0fn00">
          <div className="relative aspect-square h-[34vh]" data-id="element-101" data-mp="eh5333rft6l3">
            <div className="absolute inset-[10%] rounded-full border border-white/12" data-id="element-102" data-mp="af1o455k7jv2" />
            <div className="absolute inset-[28%]" data-id="element-103" data-mp="29jjlsmqoqhig">
              <BrainGraph density={1} className="h-full w-full" data-id="element-104" data-mp="29kur4qzs3xbo" />
            </div>
            {loop.map((item, i) => <div key={item.label} className="absolute -translate-x-1/2 -translate-y-1/2" style={position(item.angle)} data-id="element-105" data-mp="2jg4t5eq6g4pg" data-mpi={i}>
                <Reveal delay={0.06 * i} className="w-[11.5vw] text-center" data-id="element-106" data-mp="2shcdstzrt712">
                  <span className="mx-auto mb-[0.8vh] block h-[0.8vh] w-[0.8vh] rounded-full" style={{
                background: item.tone
              }} data-id="element-107" data-mp="2sf9pqfi6hnyz" />
                  <span className="text-[clamp(9px,0.98vw,21px)] leading-[1.3] text-[#DCE3EE]" data-id="element-108" data-mp="327xkz5tifjvl">
                    {item.label}
                  </span>
                </Reveal>
              </div>)}
          </div>
        </div>

        <div data-id="element-109" data-mp="3g6nigmk8rlkh">
          <span className="text-[clamp(8px,0.82vw,17px)] uppercase tracking-[0.22em] text-[#3B8CFF]" data-id="element-110" data-mp="3g65et4v9252j">
            Moat components
          </span>
          <ul className="mt-[2vh] space-y-[1.3vh]" data-id="element-111" data-mp="14kwfj2yeuucp">
            {moat.map(item => <li key={item} className="border-b border-white/8 pb-[1.3vh] text-[clamp(10px,1.08vw,23px)] text-[#DCE3EE]" data-id="element-112" data-mp="10gf2rnqgxhbf">
                {item}
              </li>)}
          </ul>
        </div>
      </div>

      <Reveal delay={0.44} className="mt-[2vh]" data-id="element-113" data-mp="1o7u7to9mqcqd">
        <Caption data-id="element-114" data-mp="1o9nc4wwrskv7">
          Customer-confidential data remains isolated per organization and is not
          used to train shared third-party models. Fund-level memory improves a
          customer&apos;s own workflows without exposing data between customers.
        </Caption>
      </Reveal>
    </Slide>;
}